// extracted by mini-css-extract-plugin
export default {"tabs":"PVTSetting_tabs__b4gAI","parentTabs":"PVTSetting_parentTabs__L1Bii"};